/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Servers_Add_DescriptionInputs */



/**
* | output |
* | --- |
* | "Connect an external MCP server. Only you can use it until you share it." |
*
* @param {Mcp_Servers_Add_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const mcp_servers_add_description = /** @type {((inputs?: Mcp_Servers_Add_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Servers_Add_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Verbinden Sie einen externen MCP-Server. Nur Sie können ihn nutzen, bis Sie ihn teilen.")
	return /** @type {LocalizedString} */ ("Connect an external MCP server. Only you can use it until you share it.")
});